/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowchannelpulsifycover4Inputs */

const en_aiflowchannelpulsifycover4 = /** @type {(inputs: Aiflowchannelpulsifycover4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify cover`)
};

const de_aiflowchannelpulsifycover4 = /** @type {(inputs: Aiflowchannelpulsifycover4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify Cover`)
};

/**
* | output |
* | --- |
* | "Pulsify cover" |
*
* @param {Aiflowchannelpulsifycover4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowchannelpulsifycover4 = /** @type {((inputs?: Aiflowchannelpulsifycover4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowchannelpulsifycover4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowchannelpulsifycover4(inputs)
	return de_aiflowchannelpulsifycover4(inputs)
});
export { aiflowchannelpulsifycover4 as "aiFlowChannelPulsifyCover" }